<kt-portlet>
    <kt-portlet-header
        [title]="getComponentTitle()"
        [class]="'class-head-lg'"
        [tooltipTitle]="'TOOLTIP.PARKING.FORM' + (ac && ac.id > 0 ? '_EDIT' : '') + '.TITLE' | translate"
        [tooltipDesc]="'TOOLTIP.PARKING.FORM' + (ac && ac.id > 0 ? '_EDIT' : '') + '.DESCRIPTION' | translate"
        [viewLoading$]="loading$"
        [sticky]="true">
        <ng-container ktAdditionalTools>
            <div class="btn-group btn-group-toggle" role="group" ngbRadioGroup name="radioBasic" [formControl]="formSelectionCtrl">
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-right-white">
                    <input ngbButton type="radio" class="btn-check" [value]="2"> Simple
                  </label>
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-left-white">
                  <input ngbButton type="radio" class="btn-check" [value]="1"> Advanced
                </label>
            </div>
        </ng-container>
        <ng-container ktPortletTools>
            <a href="javascript:;"
                (click)="back()"
                class="btn mr-2"
                mat-raised-button
                matTooltip="Back to Land List">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">Close</span>
            </a>
            <a href="javascript:;"
                color="warn"
                (click)="onSubmit(false)"
                class="btn btn-success mr-2"
                style="background-color: orange !important;"
                mat-raised-button
                matTooltip="Save to Draft">
                <span>Save draft</span>
            </a>
            <a href="javascript:;"
                color="submit"
                (click)="onSubmit(true)"
                class="btn btn-success mr-2"
                mat-raised-button
                matTooltip="Save">
                <span class="kt-hidden-mobile">Save</span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <form class="form" [formGroup]="formGroup">
            <kt-form-tab-header
                [headers]="formTabHeaders$|async"
                (tabChange)="onTabChange($event)"
            ></kt-form-tab-header>
            <mat-tab-group class="invinsible-tabs" [(selectedIndex)]="selectedTab" (selectedTabChange)="onTabChanged($event);">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Location</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <kt-map-location
                            [title]="'Location'"
                            [showMap]="true"
                            [lockMarker]="false"
                            [isComplexForm]="isComplexForm"
                            [locationData]="ac.locationData"
                            [parentType]="'comparable'"
                            [(centerLat)]="centerLat"
                            [(centerLng)]="centerLng"
                            (markerChange)="onMarkerChange($event)"
                            (timezoneChange)="onTimezoneChange($event)"
                        >
                        ></kt-map-location>

                        <div class="form-group kt-form__group row" *ngIf="isComplexForm">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile section-margin-top-60">
                                <h5 class="my-3 text-mad text-uppercase">
                                Parcel Identification 
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12 mb-2">
                                <mat-label>Would you like to add information on the land</mat-label>
                                <mat-radio-group class="ml-4" formControlName="add_info_on_land">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <ng-container *ngIf="formGroup.controls.add_info_on_land.value">
                                <div class="col-lg-12 mb-10">
                                    <kt-land-parcel-map
                                        [points]="points"
                                        [markerInfo]="markerInfo"
                                        [centerLat]="centerLat"
                                        [centerLng]="centerLng"
                                        [staticUnit]="2"
                                        [staticUnitLengthName]="'M'"
                                        [staticUnitName]="'sqm'"
                                        [isReverse]="formGroup.controls.boundary_type_id.value === 3">
                                    </kt-land-parcel-map>
                                </div>
                                <div class="col-lg-4 mb-4">
                                    <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['land_parcel_name']">
                                        <input matInput placeholder="Land Parcel ID" formControlName="land_parcel_name" type="text">
                                        <mat-hint [formFieldHintState]="formGroup.controls['land_parcel_name']">
                                            Land Parcel ID <span>required</span>
                                        </mat-hint>
                                        <mat-error>
                                            Land Parcel ID <strong>required</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 mb-4">
                                    <div class="row">
                                        <div class="col-6">
                                            Add coordinates of each boundary cover or pivot point of the land parcel ?
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-lg-6">
                                            <mat-radio-group formControlName="boundary_type_id">
                                                <mat-radio-button [value]="1">No</mat-radio-button>
                                                <mat-radio-button [value]="2">Draw</mat-radio-button>
                                                <mat-radio-button [value]="3">Write Down</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['coordinate_reference_system_id']">
                                        <mat-select placeholder="Coordinate Reference System" formControlName="coordinate_reference_system_id">
                                            <mat-option *ngFor="let coordinateReferenceSystem of coordinateReferenceSystems" [value]="coordinateReferenceSystem.id">{{coordinateReferenceSystem.name}}</mat-option>
                                        </mat-select>
                                        <mat-icon
                                            matSuffix
                                            class="cursor-pointer"
                                            (click)="$event.stopPropagation();"
                                            container="body"
                                            [ngbPopover]="'TOOLTIP.LAND_PARCEL.CRS.DESCRIPTION' | translate">help
                                        </mat-icon>
                                        <mat-hint [formFieldHintState]="formGroup.controls['coordinate_reference_system_id']">
                                            Coordinate Reference System
                                            <span>required</span>
                                        </mat-hint>
                                        <mat-error>
                                            Coordinate Reference System
                                            <strong>required</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <kt-land-area-list
                                    class="col-lg-12"
                                    [landAreaComponentListSubject]="landAreaComponentListSubject"
                                    [landAreaSubject]="landAreaSubject"
                                    [showOtherFields]="true">
                                </kt-land-area-list>
                            </ng-container>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Property & building information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                   About the property 
                                </h5>
                                <hr class="active">
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['sub_type_category_id']">
                                    <mat-select placeholder="Sub-type category" formControlName="sub_type_category_id">
                                        <mat-option *ngFor="let item of subTypeCategories" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['sub_type_category_id']">
                                        Sub-type category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-type category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="filteredSubCategories.length != 0">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['sub_category_id']">
                                    <mat-select placeholder="Sub-category" formControlName="sub_category_id">
                                        <mat-option *ngFor="let item of filteredSubCategories" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['sub_category_id']">
                                        Sub-category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['number_of_units']">
                                    <input matInput type="number" placeholder="Number of unit(s)" formControlName="number_of_units" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['number_of_units']">
                                        Number of unit(s) <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Number of unit(s) <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['parking_type_id']">
                                    <mat-select placeholder="Parking Type" formControlName="parking_type_id">
                                        <mat-option *ngFor="let item of parkingTypes" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['parking_type_id']">
                                        Parking type <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Parking type <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['state_of_repair_id']">
                                    <mat-select placeholder="State of repair" formControlName="state_of_repair_id">
                                        <mat-option *ngFor="let item of stateOfRepairs" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['state_of_repair_id']">
                                        State of Repair <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        State of Repair <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['handover_standard_id']">
                                    <mat-select placeholder="Handover standard" formControlName="handover_standard_id">
                                        <mat-option *ngFor="let item of handoverStandards" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['handover_standard_id']">
                                        Handover standard <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Handover standard <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-12 mb-2 kt-margin-bottom-10-mobile" *ngIf="isParkingGarage">
                                <tag-input 
                                    [tagFormFieldState]="floorLocationFormControl"
                                    class="floor" matInput formControlName="floor_details"
                                           [placeholder]="'PARKING.FORM.FIELD.CHARACTERISTICS.FLOOR_DETAILS.PLACEHOLDER' | translate"
                                           [secondaryPlaceholder]="'PARKING.FORM.FIELD.CHARACTERISTICS.FLOOR_DETAILS.PLACEHOLDER' | translate"
                                           modelAsStrings="true"
                                           style="width: 100%"
                                >
                                </tag-input>
                                <mat-error 
                                    [tagErrorState]="floorLocationFormControl">
                                    Floor location <strong>required</strong>
                                </mat-error>
                            </div>            
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls['automation']">
                                    <mat-select placeholder="Automation" formControlName="automation">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="0">No</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['automation']">
                                        Automation <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Automation <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-8 kt-margin-bottom-20-mobile" style="align-self: center;" *ngIf="formGroup.controls.automation.value == 1">
                                <!-- <div class="row"> -->
                                    <!-- <div class="col-lg-12"> -->
                                        <mat-radio-group   formControlName="automation_type">
                                            <mat-radio-button [value]="'full'">Automated parking system</mat-radio-button>
                                            <mat-radio-button [value]="'semi'">Semi-automated parking system</mat-radio-button>
                                        </mat-radio-group>
                                    <!-- </div> -->
                                <!-- </div> -->
                            </div>
        
        
                            <div class="kt-margin-bottom-20-mobile" [ngClass]="{'col-lg-8': formGroup.controls.automation.value != 1, 'col-lg-12': formGroup.controls.automation.value == 1}">
                                <mat-form-field class="mat-form-field-fluid">
                                    <textarea matInput rows="1" placeholder="Property general description" formControlName="property_general_desc"></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                        <kt-building-form
                            *ngIf="isComplexForm && isParkingGarage"
                            [(centerLat)]="centerLat"
                            [(centerLng)]="centerLng"
                            (centerChange)="onCenterChange($event)"
                            (picChange)="onPicChange($event)"
                            [buildingPictures]="building_pictures"
                            [buildingPicturePath]="building_picture"
                            [isComplexForm]="isComplexForm"
                            [acBuilding]="ac.buildingInfo"></kt-building-form>
        

                        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                   Services and Infrastructures 
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-services-and-infrastructures 
                                    [propertySubTypeID]="2"
                                    [isComplexForm]="isComplexForm"
                                    [serviceAndInfraData]="ac.serviceAndInfraData"
                                    ></kt-services-and-infrastructures>
                            </div>
                        </div>
                        <kt-ac-size class="section-margin-top-60" [sizesSubject]="sizesSubject" [assetClassType]="'2'"></kt-ac-size>
                        <mat-error 
                            errorStateWithLength
                            [hasFormError]="hasFormErrors"
                            [isInValid]="sizesSubject.value.length === 0"
                            [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
                            }"
                        >
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <kt-esg-indicators 
                        formType="comparable"
                        [value]="ac.esgIndicator"
                        [systemOfMeasurement]="userUnitOfMeasurementId$|async"/>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Lease & sale information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <kt-consideration-and-source
                            style="margin-top: 60px;"
                            [inputConsiderations]="tenuresSubject|async"
                            [landAreaComponentListSubject]="landAreaComponentListSubject"
                            [hasParcelInfo$]="hasParcelInfo$"
                            [timezoneOffset]="timezoneOffset"
                            [sizes]="sizes$|async"
                            (considerationsChange)="onConsiderationsChange($event)"
                            ></kt-consideration-and-source>
                        <mat-error 
                            errorStateWithLength
                            [hasFormError]="hasFormErrors"
                            [isInValid]="considerationError$|async"
                        >
                            Input <strong>required</strong>
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Pictures & documents</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="form-group row section-margin-top-60">
                            <div class="col-lg-12">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Pictures
                                </h5>
                                <hr class="active">
                            </div>
                            <kt-upload-file #simple class="col-lg-12"
                                [filesOnEditMode]="ac.ac_pictures"
                                [folderOnEditMode]="ac.picture"
                                [readOnly]="false"
                                [parentForm]="'land'"
                                [typeField]="false"
                                fileType="image/*"
                                split="1"
                                [featuredPictureAllowed]="true"
                                [hasThumbnail]="true"
                                [addButtonLabel]="'Add Parking Picture'">
                            </kt-upload-file>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error class="tag-custom-error" *ngIf="hasFormErrors && showTitleRequiredError$|async">
                                    Picture should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>
                        
                        <div class="form-group row section-margin-top-60" *ngIf="isComplexForm && isParkingGarage">
                            <div class="col-lg-12">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Building Pictures
                                </h5>
                                <hr class="active">
                            </div>
                            <kt-upload-file #buildingPic class="col-lg-12"
                                [filesOnEditMode]="ac.b_pictures"
                                [folderOnEditMode]="ac.b_picture"
                                [readOnly]="false"
                                [parentForm]="'land'"
                                [typeField]="false"
                                fileType="image/*"
                                split="2"
                                [featuredPictureAllowed]="true"
                                [hasThumbnail]="true"
                                [addButtonLabel]="'Add Building Picture'">
                            </kt-upload-file>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error class="tag-custom-error" *ngIf="showTitleRequiredError$|async">
                                    Picture should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>

                        <kt-ac-document-upload class="section-margin-top-60" [files]="ac.documents" *ngIf="isComplexForm">
                        </kt-ac-document-upload>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form>
    </kt-portlet-body>
</kt-portlet>